export type ScanningSessionFlow = "pallet" | "parcel" | "product" | "unknown";

interface IScanningSessionRepositoryStorage {
    locatorsList: string[];
    flow: Exclude<ScanningSessionFlow, "unknown">;
    warehouseCode: string;
}

export class ScanningSessionRepository {
    private _locatorList: string[] = [];
    private _flow: ScanningSessionFlow;
    private _warehouseCode: string;

    private _clearItemScanRepositoryTimeoutId: NodeJS.Timeout | undefined = undefined;

    public constructor() {
        const parsedStorage = JSON.parse(localStorage.getItem("scanning_session_repository") ?? "{}") as IScanningSessionRepositoryStorage;
        if (parsedStorage && parsedStorage.locatorsList && parsedStorage.locatorsList.length > 0 && this.isFlowValid(parsedStorage.flow)) {
            this._locatorList = parsedStorage.locatorsList;
            this._flow = parsedStorage.flow;
            this._warehouseCode = parsedStorage.warehouseCode;
            this.restartTimeout();
        }
    }

    public clear() {
        this._locatorList = [];
        this._flow = "unknown";
        this._warehouseCode = "";
        localStorage.removeItem("scanning_session_repository");
        clearTimeout(this._clearItemScanRepositoryTimeoutId);
    }

    public add(locator: string, flow: Exclude<ScanningSessionFlow, "unknown">, warehouseCode: string) {
        if (this._flow !== flow || this._warehouseCode !== warehouseCode) {
            this._locatorList = [locator];
            this._warehouseCode = warehouseCode;
            this._flow = flow;
        } else {
            this._locatorList = this._locatorList.find(l => l === locator) ? this._locatorList : [...this._locatorList, ...[locator]];
        }

        localStorage.setItem("scanning_session_repository", JSON.stringify({
            locatorsList: this._locatorList,
            flow: this._flow,
            warehouseCode: this._warehouseCode,
        } as IScanningSessionRepositoryStorage));

        this.restartTimeout();
    }

    public remove(locator: string) {
        this._locatorList = this._locatorList.filter(l => l !== locator);
        this.restartTimeout();
    }

    public resetClock() {
        this.restartTimeout();
    }

    get locatorList(): string[] {
        return this._locatorList;
    }

    get flow(): ScanningSessionFlow {
        return this._flow;
    }

    get warehouseCode(): string {
        return this._warehouseCode;
    }

    private stopTimeout() {
        if (this._clearItemScanRepositoryTimeoutId) {
            clearTimeout(this._clearItemScanRepositoryTimeoutId);
        }
    }

    private restartTimeout() {
        this.stopTimeout();
        this._clearItemScanRepositoryTimeoutId = setTimeout(() => this.clear(), 600 * 1000);
    }

    private isFlowValid(flow: string) {
        return flow === "pallet" || flow === "parcel" || flow === "product";
    }
}
